import React from 'react';
import DataGrid, {
  Column,
  Editing,
  Lookup,
  DataGridTypes,
} from 'devextreme-react/data-grid';
import useLookUpBase from '../../components/selectbox/LookupBase';
import { CaptureDetails } from './type';

interface ICapturesDetailsGrid {
  capturesDetails: CaptureDetails[];
  isModeModifier: boolean;
  selectedCaptureDetailId?: string;
  onSelectionChanged: (idCaptureDetail: string | undefined) => void;
  onDetailUpdated: (captureDetail: CaptureDetails) => void;
}

const masseFormat = { type: 'fixedPoint' as const, precision: 3 };
const longueurFormat = { type: 'fixedPoint' as const, precision: 1 };

const CapturesDetailsGrid: React.FC<ICapturesDetailsGrid> = ({
  capturesDetails,
  isModeModifier,
  selectedCaptureDetailId,
  onSelectionChanged,
  onDetailUpdated,
}) => {
  const { editorOptions: especesEditorOptions } = useLookUpBase({
    isModeModifier,
    controllerName: 'Espece',
    showClear: isModeModifier,
  });

  const handleFocusedRowChanged = (e: DataGridTypes.FocusedRowChangedEvent) => {
    onSelectionChanged(e.row?.data?.idCaptureDetail ? String(e.row.data.idCaptureDetail) : undefined);
  };

  const handleRowUpdated = (e: DataGridTypes.RowUpdatedEvent) => {
    onDetailUpdated(e.data as CaptureDetails);
  };

  return (
    <DataGrid
      dataSource={capturesDetails}
      keyExpr="idCaptureDetail"
      showBorders={true}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      focusedRowEnabled={true}
      focusedRowKey={selectedCaptureDetailId}
      onFocusedRowChanged={handleFocusedRowChanged}
      onRowUpdated={handleRowUpdated}
    >
      <Editing
        mode="cell"
        allowUpdating={isModeModifier}
        startEditAction="click"
      />
      <Column caption="">
        <Column fixed={true} caption="Espèce" dataField="idEspece">
          <Lookup {...especesEditorOptions} />
        </Column>
      </Column>
      <Column caption="Complet">
        <Column caption="Qté" dataField="completQuantite" dataType="number" />
        <Column caption="Masse" dataField="completMasse" dataType="number" format={masseFormat} />
      </Column>
      <Column caption="Éviscéré">
        <Column caption="Qté" dataField="eviscereQuantite" dataType="number" />
        <Column caption="Masse" dataField="eviscereMasse" dataType="number" format={masseFormat} />
      </Column>
      <Column caption="Étêté">
        <Column caption="Qté" dataField="eteteQuantite" dataType="number" />
        <Column caption="Masse" dataField="eteteMasse" dataType="number" format={masseFormat} />
      </Column>
      <Column caption="Consommé">
        <Column caption="Qté" dataField="consommeQuantite" dataType="number" />
      </Column>
      <Column caption="Non pesé">
        <Column caption="Qté" dataField="nonPeseeQuantite" dataType="number" />
      </Column>
      <Column caption="Remis à l'eau">
        <Column caption="Qté" dataField="remisAEau" dataType="number" />
      </Column>
      <Column caption="Divers">
        <Column caption="Longueur" dataField="longueur" dataType="number" format={longueurFormat} />
        <Column caption="Remarques" dataField="remarques" />
      </Column>
    </DataGrid>
  );
};

export default CapturesDetailsGrid;
